var Steps = (function(w) {
	
	/**
	 * Création de l'objet Steps (gestion des étape d'un formulaire)
	 * @param {configuration} config 
	 */
	w.Steps = function(config) {
		let self = this;
		this.settings = {
			steps: '[data-step]',
			progress : '.progress-step',
			progressIndex : null, // Index affiché dans la barre de progression
			activeClass: 'active',
			customOrder: true,
			activeStep: 0,
			container: document,
			backNavigator :  false,   // Gestion du back navigateur entre les étapes
			stepUrl : '#step{0}' // Url ajoutée après chaque étape   #step1 
		}

		extend(this.settings, config);

		this.collection = this.settings.container.querySelectorAll(this.settings.steps);
		this.progress = this.settings.container.querySelectorAll(this.settings.progress);

		this.activeIndex = this.settings.activeStep;

		if ( this.settings.customOrder ) {
			// Rearrange the elements based on their INDEX value
			this.reArrange();
		}

		// Gestion du back		
		if (self.settings.backNavigator===true) {
			w.history.pushState({activeIndex : this.activeIndex, url : document.location.pathname + document.location.search},'',document.location.pathname + document.location.search);
			w.onpopstate =function(event) {				
				if (event.state!==null) {
					self.toggle(self.activeIndex, event.state.activeIndex);
				}
			}
		}			
	};

	w.Steps.prototype.reArrange = function() {
		var tempSteps = [];

		for (var i = 0; i < this.collection.length; i++) {
			var el = this.collection[i];

			var index = el.getAttribute('data-step-index');

			tempSteps.splice(index, 0, el);
		};

		this.collection = tempSteps;
	};

	/**
	 * Passe à l'étape suivante
	 */
	w.Steps.prototype.next = function() {
		this.toggle(this.activeIndex, this.activeIndex + 1);
		if (this.settings.backNavigator===true) {			
			history.pushState({activeIndex : this.activeIndex, url : this.settings.stepUrl.replace('{0}',this.activeIndex + 1)},'', this.settings.stepUrl.replace('{0}',this.activeIndex + 1));
		}
	};

	/**
	 * Retour à l'étape précédente
	 */
	w.Steps.prototype.prev = function() {
		this.toggle(this.activeIndex, this.activeIndex - 1);
		if (this.settings.backNavigator===true) {
			history.back();
		}
	};

	/**
	 * Va  à l'étape d'index "index"
	 * @param {index} index 
	 */
	w.Steps.prototype.to = function(index) {
		this.toggle(this.activeIndex, parseInt(index));
		if (this.settings.backNavigator===true) {			
			history.pushState({activeIndex : this.activeIndex, url : this.settings.stepUrl.replace('{0}',this.activeIndex + 1)},'', this.settings.stepUrl.replace('{0}',this.activeIndex + 1));
		}
	};

	w.Steps.prototype.toggle = function(oldStepIndex, newStepIndex) {
		if ( this.collection[newStepIndex] != undefined ) {
			this.collection[oldStepIndex].classList.remove(this.settings.activeClass);
			this.collection[newStepIndex].classList.add(this.settings.activeClass);
			if (this.progress.length>0) {
				// Détermine le nouvel index de progression
				var newProgressIndex = newStepIndex;
				var oldProgressIndex = oldStepIndex;
				if (this.settings.progressIndex!==null) {
					oldProgressIndex = parseInt(this.collection[oldStepIndex].getAttribute(this.settings.progressIndex),10);
				}
				if (this.settings.progressIndex!==null) {
					newProgressIndex = parseInt(this.collection[newStepIndex].getAttribute(this.settings.progressIndex),10);
				}
				// Affiche le nouvel index de progression
				if (this.progress[oldProgressIndex] != undefined) {
					this.progress[oldProgressIndex].classList.remove(this.settings.activeClass);
				}
				if (this.progress[newProgressIndex] != undefined) {
					this.progress[newProgressIndex].classList.add(this.settings.activeClass);
				}
			}
			this.activeIndex = newStepIndex;
		}
	};

	/**
	 * 
	 * @returns Retourne le pourcentage de progression
	 */
	w.Steps.prototype.progress = function() {
		return ( this.activeIndex / ( this.collection.length - 1 ) ) * 100;
	};

	function extend(defaultObj, newObj) {
		for ( var i in newObj ) {
			if ( newObj.hasOwnProperty(i) ) {
				defaultObj[i] = newObj[i];
			}
		}
	};
		
	return w.Steps;
})(window);


